/* eslint-disable no-fallthrough */
export const paymentBalanceState = {
  customerCode: "",
  customerName: "",
  invoiceNumber: "",
  balance: "",

  repName: "",
  repCode: "",
  soDate: "",
  ageOfInvoice: "",
  creditLimit: "",
  category: "",
  ndays: "",
  partialPaidAmount: "",
  remainingAmount: "",
  remarks: "",

  // status
  customerCodeStatus: "unchecked",
  customerNameStatus: "unchecked",
  invoiceNumberStatus: "unchecked",
  balanceStatus: "unchecked",

  repNameStatus: "unchecked",
  repCodeStatus: "unchecked",
  soDateStatus: "unchecked",
  ageOfInvoiceStatus: "unchecked",
  creditLimitStatus: "unchecked",
  categoryStatus: "unchecked",
  ndaysStatus: "unchecked",
  partialPaidAmountStatus: "unchecked",
  remainingAmountStatus: "unchecked",
  remarksStatus: "unchecked",
};

export const PaymentBalanceStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "repCode": {
      if (value) {
        return {
          ...state,
          repCode: value,
          repCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          repCode: "",
          repCodeStatus: "unchecked",
          repName:"",
          repNameStatus:"unchecked"
        };
      }
    }
    case "category": {
      if (value) {
        return {
          ...state,
          category: value,
          categoryStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          category: "",
          categoryStatus: "unchecked",
        };
      }
    }
    case "customerCode": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          customerCode: value,
          customerCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerCode: "",
          customerCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customerCode: value,
          customerCodeStatus: "error",
        };
      }
    }
    case "repName": {
           const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          repName: value,
          repNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          repName: "",
          repNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          repName: value,
          repNameStatus: "error",
        };
      }
    }
    case "customerName": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerName: "",
          customerNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "error",
        };
      }
    }

    case "invoiceNumber": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          invoiceNumber: value,
          invoiceNumberStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          invoiceNumber: "",
          invoiceNumberStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          invoiceNumber: value,
          invoiceNumberStatus: "error",
        };
      }
    }
    case "balance": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          balance: value,
          balanceStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          balance: "",
          balanceStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          balance: value,
          balanceStatus: "error",
        };
      }
    }
   
    case "soDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          soDate: value,
          soDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          soDate: "",
          soDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          soDate: value,
          soDateStatus: "error",
        };
      }
    }
    case "ageOfInvoice": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          ageOfInvoice: value,
          ageOfInvoiceStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          ageOfInvoice: "",
          ageOfInvoiceStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          ageOfInvoice: value,
          ageOfInvoiceStatus: "error",
        };
      }
    }
    case "creditLimit": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          creditLimit: value,
          creditLimitStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          creditLimit: "",
          creditLimitStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          creditLimit: value,
          creditLimitStatus: "error",
        };
      }
    }
    case "ndays": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          ndays: value,
          ndaysStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          ndays: "",
          ndaysStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          ndays: value,
          ndaysStatus: "error",
        };
      }
    }
    case "partialPaidAmount": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          partialPaidAmount: value,
          partialPaidAmountStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          partialPaidAmount: "",
          partialPaidAmountStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          partialPaidAmount: value,
          partialPaidAmountStatus: "error",
        };
      }
    }
    case "remainingAmount": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          remainingAmount: value,
          remainingAmountStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          remainingAmount: "",
          remainingAmountStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          remainingAmount: value,
          remainingAmountStatus: "error",
        };
      }
    }
    case "remarks": {
      const alphaNLenghthRegex = new RegExp("^(.{1,200})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          remarks: value,
          remarksStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          remarks: "",
          remarksStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          remarks: value,
          remarksStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};
